<template>
  <div class="body">
    <div class="body-item">
      <div class="body-item-main">
        <div class="visit2" v-loading="!!chart_loading['visit1']">
          <div class="visit-title">第三方户数完成月度统计</div>
          <div class="visit-chart2" ref="visit1"></div>
        </div>
        <div class="visit2" v-loading="!!chart_loading['visit2']">
          <div class="visit-title">第三方金额完成月度统计</div>
          <div class="visit-chart2" ref="visit2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as echarts from "echarts";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "ThirdpartyCompletionRateYearMonth",
  inject:['where','reginWhere'],
  data(){
    return{
      list:[],
      chart_list:{},
      chart_loading:{
        visit1:true,
        visit2:true,
        visit3:true,
        visit4:true,
        visit5:true,
        visit6:true,
        visit7:true
      },
    }
  },
  mounted() {
    const that=this;
    that.chart_list={}
    window.onresize=function () {
      let chart_list_ids=Object.keys(that.chart_list)
      chart_list_ids.map(ret=>{
        that.chart_list[ret].resize();
      });
    }
    that.reData()
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.reData()
    },
    "reginWhere.project_region":function (n,o) {
      this.reData()
    },
    "reginWhere.project_name":function (n,o) {
      this.reData()
    },
    // "where2.age":function (n,o) {
    //   this.pageChange(1)
    // },
    // "where2.type":function (n,o) {
    //   this.pageChange(1)
    // },
    // "where2.urge_type":function (n,o) {
    //   this.pageChange(1)
    // },
    // "where2.start_time":function (n,o) {
    //   this.pageChange(1)
    // },
  },
  methods:{
    reData(){
      const that = this;
      that.chart_loading.visit1=true;
      that.chart_loading.visit2=true;

      that.getData(data=>{
        // console.log(data);
        that.getChart('visit1',visitOption1([
          {
            col: "dy_hj_count",
            name: "合计",
            type:"bar",
          },
          {
            col: "dy_ch_count",
            name: "催回",
            type:"bar",
          },
          {
            col: "dy_par",
            name: "催回率",
            type:"line",
          },
        ],data.count))
        that.chart_loading.visit1=false;
        that.getChart('visit2',visitOption2([
          {
            col: "dy_hj_count",
            name: "合计",
            type:"bar",
          },
          {
            col: "dy_ch_count",
            name: "催回",
            type:"bar",
          },
          {
            col: "dy_par",
            name: "催回率",
            type:"line",
          },
        ],data.money))
        that.chart_loading.visit2=false;
      })
    },
    getData(callback){
      const that = this;
      let where = {
        ...that.where2,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        // area_id:that.areaId
      }
      ButlerHttp.post("ThirdPartyLegal/getYearMonthCollection", where, res => {
        if (res.code) {
          typeof callback === "function" && callback(res.data);
          // that.initChartVisit()
        }
      });
    },
    getChart(id,option) {
      const that=this;
      let _chart={}
      if(that.chart_list[id]){
        _chart=that.chart_list[id];
        // _chart = echarts.getInstanceByDom(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }else {
        const _chart = echarts.init(that.$refs[id]);
        _chart.setOption(option);
        that.chart_list[id]=_chart
      }
      return _chart;
    }
  },
  unmounted() {
    this.chart_list={}
  }
}
function rand(num=100) {
  return Math.floor(Math.random()*num)
}
function visitOption1(groupName=[],list) {
  let cateName=list.map(ret=>ret.ym);
  let cateData=[];
  let cols=[];

  groupName.forEach((ret,index)=>{
    cols.push(ret)
    cateData[index]=list.map(ret2=>ret2[ret.col])
  })
  let d={
    "cateName":cateName,
    "cateData":cateData,
    "groupName":groupName.map(ret=>ret.name)
  }
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe'
  ];

  let series=[];
  groupName.forEach((ret,index)=>{
    series[index]={
      name: ret.name,
      type: ret.type,
      yAxisIndex: ret.type==='bar'?0:1,
      data: d.cateData[index],
      color:colors[index],
      label: {
        show: true,
        position: 'top'
      },
    }
  })


  return {
    grid: {
      x: '5%',
      width: '90%',
      // y: '12%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: d.groupName
    },
    xAxis: [
      {
        type: 'category',
        data: d.cateName,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '户数',
      },
      {
        type: 'value',
        name: '催回率（%）',
        splitLine:{
          show:false
        }
      }
    ],
    series: series
  };
}
function visitOption2(groupName=[],list) {
  let cateName=list.map(ret=>ret.ym);
  let cateData=[];
  let cols=[];

  groupName.forEach((ret,index)=>{
    cols.push(ret)
    cateData[index]=list.map(ret2=>ret2[ret.col])
  })
  let d={
    "cateName":cateName,
    "cateData":cateData,
    "groupName":groupName.map(ret=>ret.name)
  }
  const colors = [
    '#0173e7',
    '#1aad3d',
    '#e88b20',
    '#f65555',
    '#38bcbe'
  ];

  let series=[];
  groupName.forEach((ret,index)=>{
    series[index]={
      name: ret.name,
      type: ret.type,
      yAxisIndex: ret.type==='bar'?0:1,
      data: d.cateData[index],
      color:colors[index],
      label: {
        show: true,
        position: 'top'
      },
    }
  })


  return {
    grid: {
      x: '5%',
      width: '90%',
      // y: '12%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999'
        }
      }
    },
    toolbox: {
      feature: {
        saveAsImage: { show: true }
      }
    },
    legend: {
      data: d.groupName
    },
    xAxis: [
      {
        type: 'category',
        data: d.cateName,
        axisPointer: {
          type: 'shadow'
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '金额（元）',
      },
      {
        type: 'value',
        name: '催回率（%）',
        splitLine:{
          show:false
        }
      }
    ],
    series: series
  };
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body{
  display: flex;
  flex-direction: column;
  background-color: aliceblue;
  .body-item{
    .body-item-header{
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
    }
    .body-item-main{
      display: flex;
      flex-wrap: wrap;
    }
  }
}

.visit1{
  width: calc( 50% - 30px );
  height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-chart1{
    width: calc( 100% - 30px );
    height: calc(448px - 80px);
  }
  .visit-chart3{
    width: 400px;
    height: 400px;
  }
  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}


.visit2{
  width: calc( 100% - 10px );
  //height: calc(448px - 30px);
  margin: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 5px;
  position: relative;

  .visit-title{
    padding-left: 10px;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    font-weight: bold;
  }

  .visit-chart2{
    width: calc( 100% - 10px );
    height: calc(448px - 30px);
  }
  .visit-header{
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .m-2{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdpartyCompletionRateYearMonth.vue